<template>
	<div class="side_nav">
		<div class="navs">
			<ul>
				<li class="nav_li" v-for="(item,index) in topBarList" :class="{nav_act:$route.path.indexOf(item.key)!==-1}" @click="$router.replace({path:item.url,query:{random:Math.random()}})">
					<p class="nav_gt"></p>
					<p class="nav_name">{{item.title}}</p>
				</li>
			</ul>
		</div>
		<div class="contents">
			<div class="crumbs" v-if="$route.matched[1]">
				<router-link :to="{path:others.navUrl}">{{others.navName}}</router-link> >
				<font color="#AD011B">{{$route.matched[1].meta.title}}</font>
			</div>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
export default {
    props: ['topBarList', 'others']
}
</script>

<style scoped lang="scss">
	.side_nav {
		width: 1200px;
		margin: 0 auto;
		overflow: hidden;
		.contents {
			float: left;
			width: 888px;
			min-height: 300px;
			.crumbs {
				color: #323232;
				font-size: 16px;
				height: 50px;
				line-height: 80px;
			}
		}
		.navs {
			float: left;
			margin: 60px 47px 0 0;
			.nav_li {
				width: 265px;
				border-top: 1px solid #E5E5E5;
				border-bottom: 1px solid #E5E5E5;
				position: relative;
				padding: 13px 0;
				overflow: hidden;
				cursor: pointer;
				&:hover {
					border: 0!important;
					background: #EDAA42;
					.nav_name {
						color: #fff;
					}
					.nav_gt {
						border-color: #fff;
					}
				}
				&:first-child {
					border-top: 2px solid #E5E5E5;
				}
				&:last-child {
					border-bottom: 2px solid #E5E5E5;
				}
				.nav_gt {
					width: 10px;
					height: 10px;
					position: absolute;
					top: 50%;
					left: 10px;
					border-left: 2px solid #A7A7A7;
					border-bottom: 2px solid #A7A7A7;
					-webkit-transform: translate(0, -50%) rotate(-135deg);
					transform: translate(0, -50%) rotate(-135deg);
				}
				.nav_name {
					width: 220px;
					float: right;
					font-size: 18px;
					color: #646464;
					min-height: 24px;
					line-height: 24px;
					word-break: break-all;
				}
			}
			.nav_act {
				border: 0!important;
				background: #EDAA42;
				.nav_name {
					color: #fff;
				}
				.nav_gt {
					border-color: #fff;
				}
			}
		}
		.contents {
			float: left;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/sidenav.vue